<template>
<div id="auditoria_abonos">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="library_books" title="FOLIOS TXT vs VALOR DE ABONOS" class="elevation-1 px-5 py-3">
          <br>
          <v-card-text>
            <v-card-title>
              <span class="headline"></span>
            </v-card-title>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small color="secondary" @click="nuevo_registro">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-client-table ref="vuetable_periodos" :data="datos" :columns="columns" :options="options" class="elevation-1 pa-2">
              <template slot="noResults">
                <v-alert :value="true" icon="info" color="info">No se encontró ningun registro</v-alert>
              </template>

              <template slot="actions" slot-scope="props" >
                <div style="display:flex; justify-content:space-evenly; align-items:center;">
                  <v-btn text icon color="primary" title="Descargar" @click="descargar_confronta(props.row)" >
                    <v-icon dark>get_app</v-icon>
                  </v-btn>
                  <v-btn text icon color="red" title="Eliminar" @click="eliminar_registro(props.row._id)" >
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-client-table>
          </v-card-text>

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>

  <v-dialog v-model="dialog1" max-width="30%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon class="white--text" @click.native="dialog1 = false">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>Nueva Confronta Valor Abonos</strong>
          </span>
        </v-card>

      </v-card-title>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <br>
          <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar_registro">
            <v-row row wrap>
              <v-col sm="12">
                <v-text-field label="Nombre" v-model="model.nombre" :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col sm="12">
                <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on" v-model="model.fecha_abono" label="Fecha de Validación de Abonos" color="secondary" prepend-icon="event" @blur="model.fecha_abono = parseDate(model.fecha_abono)" v-mask="'####-##-##'"
                      :rules="[rules.required]"></v-text-field>
                  </template>

                  <v-date-picker v-model="model.fecha_abono" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                    <v-spacer />

                    <v-btn color="secondary" x-small @click="menu1 = false">
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col sm="12">
                <v-autocomplete v-model="model.clave_destino" :items="destinos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Clave de Retorno" :rules="[rules.required]">
                </v-autocomplete>
              </v-col>
              <v-col sm="12">
                <v-chip v-if="Array.isArray(model.archivo) && model.archivo.length > 0" class="ma-2" close color="green" outlined @click:close="model.archivo=''">Archivo Cargado Correctamente</v-chip>
                <upload-excel-component v-if="model.archivo == ''" :on-success="handleSuccess" :before-upload="beforeUpload" :firstRow='2' />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <exportar-excel :data="datos_layout.camposLayout" :exportFields="datos_layout.encabezadoLayout" :name="'LayoutConfrontaAbonos.xlsx'">
          <v-btn color="primary">
            <v-icon small>mdi-download</v-icon> Plantilla
          </v-btn>
        </exportar-excel>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.native="guardar_registro">
          <v-icon>done</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import XLSX from 'xlsx';

export default {
  created: async function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }

    this.model = this.clean_model();
    this.cargar();
    this.getDestinos();
  },
  data: () => ({
    dialog1: false,
    permisoEliminar: false,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Auditorías",
        disabled: true,
        to: ""
      },
      {
        text: "Folios TXT vs Valor de Abonos",
        disabled: true,
        to: ""
      }
    ],
    datos: [],
    destinos: [],
    columns: ["nombre", "fecha_abono", "clave_destino", "actions"],
    options: {
      filterable: true,
      sortable: true,
      headings: {
        "nombre": "Nombre",
        "fecha_abono": "Fecha Abonos",
        "clave_destino": "Clave",
        "actions": "Acciones"
      }
    },
    model: {
      rfc: "",
      nombre: "",
      fecha_abono: "",
      usuario: "",
      fecha: "",
      archivo: "",
      key: ""
    },
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    datos_layout: {
      encabezadoLayout: {
        "Fecha": "fecha",
        "Folio": "folio",
        "Valor Comercial": "valor_comercial",
        "Crédito IVA": "credito_iva",
        "Crédito IEPS": "credito_ieps"
      },
      camposLayout: [{
        fecha: "",
        folio: "",
        valor_comercial: "",
        credito_iva: "",
        credito_ieps: ""
      }],
    },
    menu1: false,
  }),
  methods: {
    clean_model: function() {
      return {
        rfc: this.$local_storage.get("rfc"),
        nombre: "",
        fecha_abono: "",
        usuario: this.$local_storage.get("id_usuario"),
        fecha: "",
        archivo: "",
        key: ""
      };
    },
    parseDateExcel(excelDate) {
      try {
        if (!excelDate) return false;
        var fecha = '';
        if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
          fecha = moment(String(excelDate)).format("YYYY-MM-DD");
        else
          fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
        if (fecha == 'Invalid date') return false;
        return fecha;
      } catch (error) {
        return false;
      }
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
      };
      axios.post(this.$apiSA31+ "soluciona31/list_confrontas_abonos/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    nuevo_registro: function() {
      this.model = this.clean_model();
      this.dialog1 = true;
    },
    guardar_registro: function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!Array.isArray(this.model.archivo) || (Array.isArray(this.model.archivo) && this.model.archivo.length == 0)) {
        this.$swal({
          type: "info",
          title: "Validación",
          text: "Debes cargar una plantilla con información requerida",
          footer: ""
        });

        return;
      }
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = this.model;

      if (data['planta'] == null || data['planta'] == "" || data['planta'] == undefined) {
        delete data['planta'];
      }

      var url = this.$apiSA31 + "soluciona31/guardar_confronta_abonos/";
      var url_test = "http://localhost:8000/soluciona31/guardar_confronta_abonos/";

      axios.post(url, data).then(response => {
          this.model = this.clean_model();
          this.$swal({
            type: "success",
            title: "Operación Exitosa",
            text: "El Registro se guardo existosamente",
            footer: ""
          });
        })
        .catch(error => {
          let mensaje;
          var titulo = "¡Operación no Permitida!";
          var tipo = "error";
          if (typeof error.response !== "undefined") {
            mensaje = error.response.data.mensaje;
          } else {
            mensaje = "Ocurrió un error reportalo con el administrador.";
          }
          this.$swal({
            type: tipo,
            title: titulo,
            text: mensaje,
            footer: ""
          });
        }).then(() => {
          this.dialog1 = false;
          this.$root.$dialogLoader.hide();
          this.cargar();
        });
    },
    eliminar_registro: function(id_registro) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id: id_registro,
          }
          axios.post(this.$apiSA31 + 'soluciona31/eliminar_confronta_abonos/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "La confronta se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar la confronta. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }
      });
    },
    descargar_confronta: function(row) {
      var name = row.nombre + "_" + this.$local_storage.get("rfc") + ".xlsx";

      var diferencias = [];
      var faltantes_archivo = [];
      var faltantes_descargos = [];

      row.diferencias.forEach((item) => {
        diferencias.push({
          "Fecha": item['fecha'],
          "Folio": item['folio'],
          "Valor Comercial SAT": item['valor_comercial_sat'],
          "Valor Comercial SoluciónA31": item['valor_comercial_soluciona'],
          "Diferencia Valor Comercial": item['diferencia'],
        });
      });

      row.faltantes_archivo.forEach((item) => {
        faltantes_archivo.push({
          "Fecha": item['fecha'],
          "Folio": item['folio'],
          "Valor Comercial": item['valor_comercial'],
        });
      });

      row.faltantes_descargos.forEach((item) => {
        faltantes_descargos.push({
          "Fecha": item['fecha'],
          "Folio": item['folio'],
          "Valor Comercial": item['valor_comercial'],
        });
      });

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(diferencias);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Confronta Abonos");

      const worksheet2 = XLSX.utils.json_to_sheet(faltantes_archivo);
      XLSX.utils.book_append_sheet(workbook, worksheet2, "En Archivo");

      const worksheet3 = XLSX.utils.json_to_sheet(faltantes_descargos);
      XLSX.utils.book_append_sheet(workbook, worksheet3, "En SoluciónA31");

      XLSX.writeFile(workbook, name, { compression: true });
    },
    beforeUpload: function(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (isLt2M) {
        return true;
      }
      this.$swal({
        type: "warning",
        title: "¡Operación no Permitida!",
        text: "El archivo no debe ser mayor a 2MB.",
        footer: ""
      });
      return false;
    },
    handleSuccess: function({results, header}) {
      var requeridos = Object.keys(this.datos_layout.encabezadoLayout);

      var valido = true;
      results.forEach((item, i) => {
        var keys = Object.keys(item);
        requeridos.forEach((item2) => {
          if (!keys.includes(item2)) {
            console.log("en los requeridos");
            console.log(item2);
            valido = false;
          }
        });
      });

      if (!valido) {
        this.$swal({
          type: "info",
          title: "Validación",
          text: "El archivo no contiene todos los campos requeridos",
          footer: "Por favor revisar que todos los campos esten llenos y con el formato correcto"
        });

        return;
      }

      results.forEach((item) => {
        item['Fecha'] = this.parseDateExcel(item['Fecha'])
        if(item['Fecha'] == false) {
          console.log("en la fecha");
          valido = false;
        } else if (item['Folio'] === '' || item['Valor Comercial'] === '' || item['Crédito IVA'] === '' || item['Crédito IEPS'] === '') {
          valido = false;
        }
      });

      if (!valido) {
        this.$swal({
          type: "info",
          title: "Validación",
          text: "El archivo contiene campos vacios o fechas con formato incorrecto",
          footer: "Por favor revisar que todos los campos esten llenos y con el formato correcto"
        });

        return;
      }

      this.model.archivo = [];
      results.forEach((item) => {
        this.model.archivo.push({
          "fecha": item['Fecha'],
          "folio": item['Folio'],
          "valor_comercial": item['Valor Comercial'],
          "credito_iva": item['Crédito IVA'],
          "credito_ieps": item['Crédito IEPS']
        });
      });
    },
    getDestinos: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = {
        "rfc": this.model.rfc
      };

      axios({
          method: "post",
          url: this.$apiSA31 + "soluciona31/reportes/get_destinos_cliente/",
          data: data
        })
        .then(response => {
          if (response.data && response.data.length) {
            this.destinos = response.data
          } else {
            this.destinos = [];
          }
        }).catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los destinos. Intente nuevamente.",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>
